// import React from "react";

// import { Store } from "react-notifications-component";
// const Notification = (
//   title: string,
//   message: string,
//   type: "success" | "danger" | "info" | "default" | "warning"
// ) => {
//   Store.addNotification({
//     title: title,
//     message: message,
//     type: type,
//     insert: "top",
//     container: "top-right",
//     animationIn: ["animate__animated", "animate__fadeIn"],
//     animationOut: ["animate__animated", "animate__fadeOut"],
//     dismiss: {
//       duration: 5000,
//       showIcon: true,
//     },
//   });
// };
// export default Notification;

import React from "react";
import { Store } from "react-notifications-component";

const Notification = (
  title: string,
  message: string,
  type: "success" | "danger" | "info" | "default" | "warning",
) => {
  const isMobile = window.innerWidth < 640;

  Store.addNotification({
    title,
    message,
    type,

    insert: "top",

    container: isMobile ? "top-center" : "top-right",

    animationIn: ["animate__animated", "animate__fadeIn"],

    animationOut: ["animate__animated", "animate__fadeOut"],

    dismiss: {
      duration: 5000,
      showIcon: true,
      pauseOnHover: true,
    },

    width: isMobile ? window.innerWidth - 20 : 400,

    touchSlidingExit: {
      swipe: {
        duration: 300,
        timingFunction: "ease-out",
        delay: 0,
      },

      fade: {
        duration: 300,
        timingFunction: "ease-out",
        delay: 0,
      },
    },
  });
};

export default Notification;
